import { PluginOlasioRequest } from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runOlasioRequest = (
  constructPost: ConstructPost,
  data: PluginOlasioRequest,
): Promise<NonPaginatedResponse<null> | undefined> =>
  constructPost<NonPaginatedResponse<null>>(
    `${PLUGIN_BASE_PATH}/olasio-request`,
    { data },
    { preventDefaultErrorToast: true },
  );
